<div *ngIf="collection" class="main-content" #summaryCard>
  <mat-card *ngIf="collectionAvailableData" class="summary-card mb-5">
    <mat-card-content>
      <!--<div><strong>Monitoring Station:</strong> {{ collection.isMonitoringStation ? 'Yes' : 'No' }}</div>-->
      <div *ngIf="collection.category"><strong>Category:</strong> {{ collection.category }}</div>
      <div *ngIf="variableKeys"><strong>Total Variables:</strong> {{ variableKeys.length }}</div>
      <div *ngIf="minAvailableDate && maxAvailableDate">
        <strong>Date Range:</strong>
        {{ minAvailableDate | date: 'dd-MM-yyyy' }} – {{ maxAvailableDate | date: 'dd-MM-yyyy' }}
      </div>
      <div *ngIf="variableKeys" class="flex flex-wrap"><strong>Stations:</strong>
        <div *ngFor="let station of datasetStations" class="ms-1 me-1">{{ station }}</div>
      </div>
      <div *ngIf="variableKeys?.length" class="variable-chips">
        <strong>Measured Variables:</strong>
        <div class="variable-chip-list">
          <span *ngFor="let key of variableKeys" class="variable-chip">{{ key | variableDisplayName: publicNamesMap }}</span>
        </div>
      </div>
      <div *ngIf="collection.citation_text" class="mt-2">
        <strong>Access and use constraints:</strong> {{ collection.citation_text }}
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Search Input for Variables -->
  <mat-form-field *ngIf="collectionAvailableData" appearance="outline" class="variable-search">
    <mat-label>Search Variables</mat-label>
    <input matInput [(ngModel)]="variableSearchTerm" placeholder="Type to filter..." />
  </mat-form-field>


  <!-- Variable Data Accordion -->
  <div>
    <mat-accordion class="variable-accordion">
      <mat-expansion-panel *ngFor="let key of filteredVariableKeys" [attr.id]="'variable-' + key">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ key | variableDisplayName: publicNamesMap }}</mat-panel-title>
          <mat-panel-description>
            {{ collectionAvailableData[key]?.length || 0 }} stations
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Table -->
        <table class="variable-table">
          <thead>
          <tr>
            <th>Station</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Depths (Min - Max)</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let entry of collectionAvailableData[key]">
            <td>{{ entry.station }}</td>
            <td>{{ entry.fromDate | date: 'dd-MM-yyyy' }}</td>
            <td>{{ entry.toDate | date: 'dd-MM-yyyy' }}</td>
            <td>
              {{ entry.depths?.length ? (entry.depths | min) + ' - ' + (entry.depths | max) : 'N/A' }}
            </td>
          </tr>
          </tbody>
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
